module.exports = __webpack_public_path__ + "static/media/Pam.fa8ad773.png";